module.exports = __webpack_public_path__ + "img/avatar-03.Bd1VePLx.65bc072b.jpg";